import { render, staticRenderFns } from "./MedItemList.vue?vue&type=template&id=f8949802&scoped=true&"
import script from "./MedItemList.vue?vue&type=script&lang=js&"
export * from "./MedItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8949802",
  null
  
)

export default component.exports